import * as React from 'react';
import { useRouteData } from 'react-static';
import { useDebug } from '../../common/hooks/useDebug';
import { useTranslations } from '../../common/translation';
import { Button } from '../../components/button/Button';
import { StyledPage } from '../../components/catch/Catch.styles';
import { HeadTitle } from '../../components/head-title/HeadTitle';
import { RowHeader } from '../../components/row-header/RowHeader';
import { DefaultLayout } from '../default/DefaultLayout';
import { LocaleProps } from '../default/DefaultLayout.props';
import translations from './translations';

// noinspection JSUnusedGlobalSymbols
export default () => {
  const { locale, translatedPaths } = useRouteData<LocaleProps>();
  const { t } = useTranslations(translations, locale);

  useDebug('app:layout:OopsLayout', { props: { locale } });

  return (
    <DefaultLayout locale={locale} translatedPaths={translatedPaths}>
      <HeadTitle title={t('pageTitle', 'Oops!')} />
      <RowHeader headingTag='h1' title={t('panelTitle', 'Oops!')} />
      <StyledPage>
        <h2>{t('somethingWrongText', 'It looks like something has gone wrong.')}</h2>
        <p>{t('pleaseReloadText', 'Please click on the button below to return home.')}</p>
        <Button title={t('homeButton', 'Home')} href='/'>
          {t('homeButton', 'Home')}
        </Button>
      </StyledPage>
    </DefaultLayout>
  );
};
